import './mw-highmaps';
import icon from './heat-map.png.js';
import template from './worldclickheat_widget_view.html';
import templateMaxView from './worldclickheat_widget_max.html';
import templateReportView from './worldclickheat_widget_report.html';


const REGIONAL_STRING = 'regional';
//  A disgusting, vile solution to resolve issues with regional histograms
//  The function iterates over the data returned and consoliates the region and the region's regional datapoints
//  Returns an array of consolidated datapoints with the string ' regional' append to each region
//  The string ' regional' necessary to append for the UI to render the map
//  Only invoked for regional queries
//  I tire of this legacy code --- Dr. Porfhattan
function regionalConsolidator(data) {
    const consolidatedDataArr = [];
    const dataObject = {};
    const sortedKeys = [];
    // Creates an object where the key is the region name
    for (const obj of data) {
        sortedKeys.push(obj.region);
        dataObject[obj.region] = obj;
    }

    for (let i = 0; i < sortedKeys.length; i++) {
        const regionName = sortedKeys[i];
        const regionNameWithRegional = `${regionName} ${REGIONAL_STRING}`;

        if (dataObject[regionName] && !(dataObject[regionNameWithRegional]) && regionName.indexOf(REGIONAL_STRING) < 0) {
        // For Regions with NO regional datapoint
        // Just add to the results;
            const regionToPush = dataObject[regionName];
            regionToPush.region = regionNameWithRegional;
            consolidatedDataArr.push(regionToPush);
        } else if (regionName.indexOf(REGIONAL_STRING) >= 0) {
        // For regions with regional datapoints, combine the data
        // and push on to the results. If no state level data exists 
        // then simply set the volume of state data to 0
            const regionalData = dataObject[regionName];
            const strippedRegionName = regionName.replace(` ${REGIONAL_STRING}`, '');
            const stateData = dataObject[strippedRegionName];
            const stateVolume = stateData ? stateData.volume : 0;
            const newStateData = {
                region: regionName,
                volume: regionalData.volume + stateVolume
            };

            consolidatedDataArr.push(newStateData);
        }
    }
    return consolidatedDataArr;
}

angular.module('MW.v11n.WorldclickheatWidget', [
    'MW.Framework.GeoService',
    'MW.Dashboard.DashboardWidgetService',
    'MW.Dashboard.DashboardStateService',
    'MW.Framework.TranslationService',
    'MW.InsDashboard.insightsBackendService',
    'DashboardChartConfigService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.v11n.MapService',
    'MW.Framework.CoreBreadcrumb',
    'MW.v11n.MapHighChart',
    'MW.Framework.AppChromeService',
    'MW.Configuration',
    'MW.Framework.InformationTypeService'
])
.directive('worldclickheatWidget', [
    'GeoService',
    'DashboardWidgetService',
    'DashboardStateService',
    'translationService',
    'insightsBackendService',
    'DashboardChartConfigService',
    'InsWidgetConfigService',
    '$window',
    'MapService',
    '$routeParams',
    '$location',
    'Breadcrumb',
    'CoreCommon',
    '$state',
    function(GeoService,
        DashboardWidgetService,
        DashboardStateService,
        translationService,
        insightsBackendService,
        DashboardChartConfigService,
        InsWidgetConfigService,
        $window,
        MapService,
        $routeParams,
        $location,
        Breadcrumb,
        CoreCommon,
        $state) {

    var v11nWidget = DashboardWidgetService.getWidget('worldclickheat-widget');

    v11nWidget.reportViewFile = 'worldclickheat_widget_report';
    v11nWidget.maximizedViewFile = 'worldclickheat_widget_max';

    var v11nWidgetController = function($scope){
        $scope.initSettings = function() {
            if ($scope.widget.settings.selectedMapType.type === 'continent') {
                $scope.documentRequest = {'country':$scope.continentToCountrylist()};
            } else if ($scope.widget.settings.selectedMapType.type === 'country'){
                $scope.documentRequest = {'country':$scope.widget.settings.selectedMapType.code};
            }

            /*
            Apply country filter if any to the document request
            */
            if ($scope.widget.filters.hasOwnProperty('Country')) {
                $scope.documentRequest['country'] = $scope.widget.filters['Country'].value.join();
            }



            InsWidgetConfigService.readyWidgetData($scope);
        };
    };

    var v11nWidgetLink = function(scope, element) {

        if (!scope.widget.settings.selectedMapType) {
            scope.widget.settings.selectedMapType = scope.widget.availableMapTypes[0].group[0];
        }


        var mapObjDict = {};
        for (var i = scope.widget.availableMapTypes.length - 1; i >= 0; i--) {
            for (var j = scope.widget.availableMapTypes[i].group.length - 1; j >= 0; j--) {
                mapObjDict[scope.widget.availableMapTypes[i].group[j].id] = scope.widget.availableMapTypes[i].group[j];
            };
        };

        scope.widget.settings.selectedMapType = mapObjDict[scope.widget.settings.selectedMapType.id]

        
        var getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.labelVisibility) ? scope.widget.settings.labelVisibility[0].id : scope.widget.availableLabelVisibility[0].id;
        };
        scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;

        scope.widgetIsLoading = false;
        scope.notConfigured = false;
        scope.fetching = false;
        scope.serviceError = false;
        scope.noDataFromServer = false;
        scope.documentRequest = {};
        scope.insightsService = 'consolidatedService';
        scope.countries = [];
        scope.activeId ='';
        var regionalDrilldownCountries = ['us', 'br', 'au', 'ar', 'ca', 'fr', 'de'];

        var continents = GeoService.getContinentList();
        var continentCodeToNameDict = {};
        for(var i = 0; i < continents.length; i++) {
            continentCodeToNameDict[continents[i].val] = continents[i].name;
        }
        continentCodeToNameDict['oc'] = 'Oceania';

        GeoService.getCountryList().then(function(countryList) {
            scope.countries = countryList;
        });

        var getRequestParams = function getRequestParams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        };

        scope.$on('$locationChangeSuccess', function(event, newVal, oldVal) {

            var newParams, oldParams, newSelection, oldSelection, type;
            if(newVal == oldVal) { return; }
            newParams = getRequestParams(newVal);
            oldParams = getRequestParams(oldVal);

            var continent = null,
                country = null;

            if(newParams.continent) {
                type = 'continent';
                if(newParams.country) {
                    type = 'country';
                }
                newSelection = decodeURI((newParams.country || newParams.continent).replace(/(%20)/g, ' '));
                continent = newParams.continent;
            }

            if(newParams.country && !newParams.continent) {
                type = 'country';
                if(newParams.region) {
                    type = 'region';
                }
                country = newParams.country;
                newSelection = decodeURI((newParams.region || newParams.country).replace(/(%20)/g, ' '));
            }

            if(newParams.continent) {
                type = 'continent';
                if(newParams.country) {
                    type = 'country';
                    if(newParams.region) {
                        type = 'region';
                        continent = newParams.continent;
                        country = newParams.country;
                    }
                }
                newSelection = decodeURI((newParams.region || newParams.country || newParams.continent).replace(/(%20)/g, ' '));
            }
            if(!newParams.continent && !newParams.country && newParams.region) {
                type = 'region';

                newSelection = decodeURI((newParams.region).replace(/(%20)/g, ' '));
            }

            if(oldParams.country) {
                oldSelection = decodeURI((oldParams.region || oldParams.country || oldParams.continent).replace(/(%20)/g, ' '));
            }

            if(oldParams.continent) {
                oldSelection = decodeURI((oldParams.country || oldParams.continent).replace(/(%20)/g, ' '));
            }

            if(type == 'country') {
                resolveCountryNameAndUpdateBreadcrumb({
                    country: newSelection,
                    continent: continent
                })
            } else if(type == 'region') {
                var regionObj = {
                    region: newSelection,
                    country: country,
                };
                if(continent != null) {
                    regionObj['continent'] = continent;
                }
                updateBreadcrumb(regionObj);
            } else if(type == 'continent') {
                resolveContinentNameAndUpdateBreadcrumb({continent: newSelection});
            }

            if(scope.isMaximized && oldSelection && !newSelection) {
                $state.reload($state.current.name);
            } else if(newParams.region) {

                if('country' in newParams) {
                    scope.documentRequest['country'] = newParams.country;
                    InsWidgetConfigService.queryRequestSettings.country = newParams.country;
                }
                
                const selectionIncludeRegion = newSelection.replace(` ${REGIONAL_STRING}`,'');
                const listOfRegions = `${selectionIncludeRegion},${selectionIncludeRegion} ${REGIONAL_STRING}`;
                
                scope.documentRequest['region'] = listOfRegions;
                InsWidgetConfigService.queryRequestSettings.region =  listOfRegions;

                //apply country filter if any
                if (scope.widget.filters.hasOwnProperty('Country')) {
                    InsWidgetConfigService.queryRequestSettings.country = scope.widget.filters['Country'].value.join();
                }

                scope.$broadcast('contentStream_documentsLoad', InsWidgetConfigService.queryRequestSettings);
                if(oldParams.country != newParams.country) {
                    scope.fetchData();
                }
            } else if(newParams.country) {
                scope.documentParams['continent'] = newParams.continent;
                scope.documentRequest['country'] = newSelection;
                scope.documentRequest['region'] = null;
                InsWidgetConfigService.queryRequestSettings.continent = newParams.continent;
                InsWidgetConfigService.queryRequestSettings.country = newSelection;
                InsWidgetConfigService.queryRequestSettings.region = null;

                //apply country filter if any
                if (scope.widget.filters.hasOwnProperty('Country')) {
                    InsWidgetConfigService.queryRequestSettings.country = scope.widget.filters['Country'].value.join();
                }

                if(regionalDrilldownCountries.indexOf(newParams.country) > -1) {
                    if(oldParams.country != newParams.country) {
                        scope.fetchData(newParams.country, newParams.continent);
                    } else if(oldParams.region != newParams.region) {
                        scope.fetchData(newParams.country, newParams.continent);
                    }
                } else {
                    if(regionalDrilldownCountries.indexOf(oldParams.country) > -1) {
                        scope.fetchData();
                    }
                }
            }
            else if(newParams.continent) {
                var countryList = scope.continentToCountrylist(newSelection);
                scope.documentRequest['continent'] = newSelection;
                scope.documentRequest['country'] = countryList;
                InsWidgetConfigService.queryRequestSettings.continent = newSelection;
                InsWidgetConfigService.queryRequestSettings.country = countryList;
                scope.fetchData(undefined, newSelection);

                //apply country filter if any
                if (scope.widget.filters.hasOwnProperty('Country')) {
                    InsWidgetConfigService.queryRequestSettings.country = scope.widget.filters['Country'].value.join();
                }
            }

            //We watch for updateContentStreamQuery on widget_content_stream_maximized.
            if (scope.isMaximized) {
                scope.updateContentStreamQuery = {
                    query: InsWidgetConfigService.queryRequestSettings
                };
            } else { //Use the old content stream.
                scope.$broadcast('contentStream_documentsLoad', InsWidgetConfigService.queryRequestSettings);
            }
        });

        scope.continentToCountrylist = function(continent) {
            if (continent === undefined) {
                continent = scope.widget.settings.selectedMapType.code;
            }

            if (continent === 'oc') {
                continent = 'ao';
            }

            var countryList = GeoService.getContinentAndCountryMappingList()[continent];
            return countryList.join(",");
        }


        scope.drill = function(id, type, parentCountry, parentContinent) {
                if (type == 'country' || type == 'continent' || type === 'region' || (scope.isMaximized && !scope.initialRegionState)) {
                    var queryParams = {};
                    if (id) {
                        queryParams['drilled'] = true;
                    }
                    if (type == 'continent') {
                        queryParams['continent'] = id;
                    }
                    if (type === 'country') {
                        if(parentCountry) {
                            queryParams['continent'] = parentCountry;
                        }
                        queryParams['country'] = id;
                    } else if (type === 'region') {
                        if(parentContinent) {
                            queryParams['continent'] = parentContinent;
                        }
                        if(parentCountry) {
                            queryParams['country'] = parentCountry;
                            if(parentCountry != 'us') {
                                id += ' regional';
                            }
                        }
                        if(!parentCountry || parentCountry === 'undefined') {
                            if(scope.widget.settings.selectedMapType.code != 'us') {
                                id+= ' regional';
                            }
                        }
                        queryParams['region'] = id;
                    }
                    updateLocationURL(queryParams);
                }

                if (scope.documentRequest.continent) {
                    delete scope.documentRequest.continent;
                }
                if (scope.documentRequest.country) {
                    delete scope.documentRequest.country;
                }
                if (scope.documentRequest.region) {
                    delete scope.documentRequest.region;
                }
                if (type == 'continent') {
                    var countryList = scope.continentToCountrylist(id);
                    scope.documentRequest.continent = id;
                    scope.documentRequest.country = countryList;
                } else if (type == 'country') {
                    scope.documentRequest.country = id;
                    scope.documentRequest.continent = parentCountry;
                } else if (type == 'region') {
                    scope.documentRequest.region = id;
                }
            //}
            scope.$broadcast('contentStream_documentsLoad', scope.documentRequest);
        };

        var resolveCountryNameAndUpdateBreadcrumb = function resolveCountryNameAndUpdateBreadcrumb(queryParams) {
            var queryParameters = {};
            angular.copy(queryParams, queryParameters);
            GeoService.convertCountryCodeToName(queryParams.country).then(function(country) {

                queryParameters.country = country;
                queryParameters.continent = continentCodeToNameDict[queryParameters.continent];
                updateBreadcrumb(queryParameters)
            });

        }

        var resolveContinentNameAndUpdateBreadcrumb = function resolveContinentNameAndUpdateBreadcrumb(queryParams) {
            var queryParameters = {};
            angular.copy(queryParams, queryParameters);
            var continentList = GeoService.getContinentList();
            queryParameters.continent = continentCodeToNameDict[queryParams.continent];
            updateBreadcrumb(queryParameters)
        }

        var updateLocationURL = function(queryParams) {
            var maxPath,
                editMode = $routeParams.editMode || false;

            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            var urlQuery = {
                editMode:editMode
            };
            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop]
            }

            if(!queryParams.region && queryParams.country && !queryParams.continent) {
                resolveCountryNameAndUpdateBreadcrumb(queryParams);
            } else if(!queryParams.region && !queryParams.country && queryParams.continent) {
                var queryParameters = {};
                angular.copy(queryParams, queryParameters);
                resolveContinentNameAndUpdateBreadcrumb(queryParameters)
            } else if(queryParams.region && queryParams.country && !queryParams.continent){
                updateBreadcrumb(queryParams);
            } else if(queryParams.region && queryParams.country && queryParams.continent) {
                updateBreadcrumb(queryParams);
            }

            $location.path(maxPath).search(urlQuery);
        };


        var updateBreadcrumb = function updateBreadcrumb(queryParams) {
            var dashboardPath,
                widgetPath,
                selectionTitle = '',
                dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

            scope.breadcrumbs =[];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];
            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;
            if(queryParams.region) {
                selectionTitle += queryParams.region;
            } else if(queryParams.country) {
                selectionTitle += queryParams.country;
            } else if(queryParams.continent) {
                selectionTitle += queryParams.continent;
            }
            scope.breadcrumbs.push(Breadcrumb.build({name:scope.dashboard.title, link:dashboardPath }));
            if(selectionTitle === '') {
               var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                   subCrumbs = [],
                   myNewPath,
                   subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title}));
            } else {
                if(selectionTitle.indexOf('regional') != -1)
                        selectionTitle = selectionTitle.substring(0, selectionTitle.indexOf('regional') - 1);
                if(!queryParams.region && queryParams.country && queryParams.continent) {
                    var countryObj = {
                        name: translationService.getLocalizedString(queryParams.continent),
                        link: dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false&drilled&continent=' + (scope.documentParams.continent || $routeParams.continent),
                        isClickable: function isClickable() { return true; }
                    }
                    widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                    scope.breadcrumbs.push(Breadcrumb.build({
                        name: scope.widget.title,
                        link: widgetPath
                    }));
                    scope.breadcrumbs.push(Breadcrumb.build({name:countryObj.name, link: countryObj.link}));
                    scope.breadcrumbs.push(Breadcrumb.build({
                        name: selectionTitle
                    }));
                } else if(queryParams.region && queryParams.country && queryParams.continent){
                    //this is a bit strange, why call it again?
                    GeoService.convertCountryCodeToName($routeParams.country || scope.documentParams.country).then(function(country) {
                        var continentObj = {
                            name: translationService.getLocalizedString(continentCodeToNameDict[queryParams.continent]),
                            link: dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false&drilled&continent=' + (scope.documentParams.continent || $routeParams.continent),
                            isClickable: function isClickable() { return true; }
                        }

                        var countryObj = {
                            name: translationService.getLocalizedString(country),
                            link: dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false&drilled&continent=' + (scope.documentParams.continent || $routeParams.continent) + '&country=' + (scope.documentParams.country || $routeParams.country),
                            isClickable: function isClickable() { return true; }
                        }
                        widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                        scope.breadcrumbs.push(Breadcrumb.build({
                            name: scope.widget.title,
                            link: widgetPath
                        }));
                        scope.breadcrumbs.push(Breadcrumb.build({name:continentObj.name, link: continentObj.link}));
                        scope.breadcrumbs.push(Breadcrumb.build({name:countryObj.name, link: countryObj.link}));
                        scope.breadcrumbs.push(Breadcrumb.build({
                            name: selectionTitle
                        }));
                    });
                } else if(queryParams.region && queryParams.country) {
                    GeoService.convertCountryCodeToName($routeParams.country || scope.documentParams.country).then(function(country) {

                        var countryObj = {
                            name: translationService.getLocalizedString(country),
                            link: dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false&drilled&country=' + (scope.documentParams.country || $routeParams.country),
                            isClickable: function isClickable() { return true; }
                        }
                        widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                        scope.breadcrumbs.push(Breadcrumb.build({
                            name: scope.widget.title,
                            link: widgetPath
                        }));
                        scope.breadcrumbs.push(Breadcrumb.build({name:countryObj.name, link: countryObj.link}));
                        scope.breadcrumbs.push(Breadcrumb.build({
                            name: selectionTitle
                        }));
                    });
                } else {
                    widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                    scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, link: widgetPath}));
                    scope.breadcrumbs.push(Breadcrumb.build({name:selectionTitle}));
                }
            }
        }

        var processData = function(data, type) {
            let server_data = data,
                serverDataLength = typeof server_data !== 'undefined' ? server_data.length : 0;
            
            if (type === 'region' && scope.documentRequest.country !== 'us') {
                // Consolidation of regional datapoints for NON-US Countries
                // See top of file for pathetic justification
                server_data = regionalConsolidator(server_data);
                serverDataLength = server_data.length;
            }
            
            var mapdata = [],
                total = 0;
            for(var i = 0, max = serverDataLength; i < max; i += 1 ) {
                total += server_data[i]['volume'];
                var obj = {
                    'hc-key': ((type == 'country' || type == 'continent') ? server_data[i]['country'] : server_data[i]['region']),
                    'value': server_data[i]['volume'],
                    'type': type
                };

                if(regionalDrilldownCountries.indexOf(obj['hc-key']) > -1) {
                    obj.drilldown = obj['hc-key'];
                }
                mapdata.push(obj);
            }

            for(i = 0, max = serverDataLength; i < max; i += 1 ) {
                if (total == 0)
                    mapdata[i].percentage = 0;
                else
                    mapdata[i].percentage = (mapdata[i].value / total) * 100;
            }
            
            return mapdata;
        }

        var prepareDocumentParams = function prepareDocumentParams(regional){
            var partialParams = {
                size: scope.widget.settings.size
            };

            if(regional){
                partialParams.object = 'regionHistograms';
                partialParams.insObject = 'regionHistograms';
            } else {
                partialParams.object = 'countryHistograms';
                partialParams.insObject = 'countryHistograms';
            }

            if(scope.inputs){
                switch(scope.inputs[0].inputType){
                    case 'rss':
                        partialParams.rssFeeds = [scope.inputs[0].id];
                        scope.activeId = scope.inputs[0].id;
                        break;
                    case 'tags':
                        partialParams.tags = [scope.inputs[0].name];
                        scope.activeId = scope.inputs[0].name;
                        break;
                    default:
                        partialParams.agents = [scope.inputs[0].id];
                        scope.activeId = scope.inputs[0].id;
                        break;
                }
            } else if (scope.searches) {
                scope.activeId = scope.searches[0]['agent'];
                partialParams.agents = [scope.activeId];
            }

            return angular.extend(partialParams,scope.chartRequest);
        };

        scope.drillmap = function(id, type, callback) {
            var isRegion = (type == 'region') ? true : false;
            //filter on drilled country
            var params = {};
            if(type != 'continent') {
                params.country = id;
            }
            scope.documentParams = angular.extend(scope.documentParams , params)
            insightsBackendService[scope.insightsService].query(scope.documentParams, function(data){
                var mapdata = processData(data['data'][0][scope.activeId.toString()].datapoints, type);
                callback(mapdata);
            });
        }

        // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
        scope.$on('widgetFiltersUpdated', function() { scope.fetchData(); });
        scope.initialRegionState = false;
        var checkRoutes = function checkRoutes() {
            if(!$routeParams.region && $routeParams.country) {
                resolveCountryNameAndUpdateBreadcrumb($routeParams);
            } else if($routeParams.region) {
                updateBreadcrumb($routeParams);
                scope.initialRegionState = true;
            } else if($routeParams.continent) {
                resolveContinentNameAndUpdateBreadcrumb({continent: $routeParams.continent})
            }
        };

        var getContinentVolume = function(continent, countryList, data) {
            var volume = 0;
            for (var i = data.length - 1; i >= 0; i--) {
                if (countryList.indexOf(data[i].country) > -1) {
                    volume += data[i].volume;
                }
            };
            return volume;
        }

        var continentData = function(data) {
            var continentsShownInMap = ['af', 'as', 'eu', 'sa', 'na', 'ao'];

            var server_data = data,
                serverDataLength = typeof server_data !== 'undefined' ? server_data.length : 0;
            var mapdata = [],
                total = 0;

            for (var continent in GeoService.getContinentAndCountryMappingList()) {
                if (continentsShownInMap.indexOf(continent) === -1) {
                    continue;
                }

                var volume = getContinentVolume(continent, GeoService.getContinentAndCountryMappingList()[continent], data);
                total += volume;
                if (continent === 'ao') {
                    continent = 'oc';
                }
                mapdata.push({
                    'hc-key': continent,
                    'value': volume,
                    'drilldown': continent,
                    'type': 'continent'
                });
            }

            for (var i = 0, max = mapdata.length; i < max; i += 1) {
                if (total == 0)
                    mapdata[i].percentage = 0;
                else
                    mapdata[i].percentage = (mapdata[i].value / total) * 100;
            }
            return mapdata;
        }

        scope.fetchData = function(country, continent) {
            scope.initSettings();

            if(!scope.readyToQuery) return;

            scope.widgetIsLoading = true;
            scope.serviceError = false;
            scope.noDataFromServer = false;
            scope.notConfigured = false;

            //check if continental maps or detailed country maps
            if (scope.widget.settings.selectedMapType.type === 'country') {
                //detailed country map
                scope.documentParams = prepareDocumentParams(true);
                scope.documentParams.country = scope.widget.settings.selectedMapType.code;
            } else {
                scope.documentParams = prepareDocumentParams();
            }

            if (scope.widget.filters.hasOwnProperty('Country')) {
                scope.documentParams.country = scope.widget.filters['Country'].value.join();
            } else {
                if (country) {
                    scope.documentParams = prepareDocumentParams(true);
                    scope.documentParams.country = country;
                }
            }
            
            insightsBackendService['consolidatedService'].query(scope.documentParams, function(data) {

                    var server_data = data['data'][0][scope.activeId.toString()].datapoints,
                        serverDataLength = typeof server_data !== 'undefined' ? server_data.length : 0;

                    if (scope.widget.settings.selectedMapType.type === 'country' || country != undefined || continent != undefined) {
                        if(continent != undefined && country != undefined) {
                            var mapdata = processData(server_data, 'region');
                        } else if(continent != undefined) {
                            var mapdata = processData(server_data, 'country');
                        } else {
                            var mapdata = processData(server_data, 'region');
                        }
                    } else if (scope.widget.settings.selectedMapType.code === 'world-continents') {
                        var mapdata = continentData(server_data);
                    }
                    else {
                        var mapdata = [],
                            total = 0;
                        for (var i = 0, max = serverDataLength; i < max; i += 1) {
                            total += server_data[i]['volume'];
                            //drilldown support for US, BR, AU and AR
                            if (regionalDrilldownCountries.indexOf(server_data[i]['country']) !== -1) {
                                mapdata.push({
                                    'hc-key': server_data[i]['country'],
                                    'value': server_data[i]['volume'],
                                    'drilldown': server_data[i]['country'],
                                    'type': 'country'
                                });
                            } else {
                                mapdata.push({
                                    'hc-key': server_data[i]['country'],
                                    'value': server_data[i]['volume'],
                                    'type': 'country'

                                });
                            }
                        }
                        for (i = 0, max = serverDataLength; i < max; i += 1) {
                            if (total == 0)
                                mapdata[i].percentage = 0;
                            else
                                mapdata[i].percentage = (mapdata[i].value / total) * 100;
                        }
                    }
                    var geoSource;
                    if(continent && country) {
                        geoSource = 'countries/' + country + '/' + country + '-all';
                    } else if(continent) {
                        if(continent == 'as') {
                            geoSource = 'custom/asia';
                        } else if(continent == 'na') {
                            geoSource = 'custom/north-america';
                        } else if(continent == 'af') {
                            geoSource = 'custom/africa';
                        } else if(continent == 'sa') {
                            geoSource = 'custom/south-america';
                        } else if(continent == 'eu') {
                            geoSource = 'custom/europe';
                        } else if(continent == 'oc') {
                            geoSource = 'custom/oceania';
                        }
                    } else if (country) {
                        geoSource = 'countries/' + country + '/' + country + '-all';
                    } else {

                        geoSource = scope.widget.settings.selectedMapType.id;
                    }

                    checkRoutes();

                    var mapSettings = {
                        data: mapdata,
                        geoSource: geoSource,
                        dataLabels: scope.labelVisibility,
                        legend: (scope.isMaximized) ? true : false,
                        color: MapService.colorPalettes.orange
                    };
                     
                    scope.mapSettings = mapSettings;
                    scope.widgetIsLoading = false;
                },
                function() {
                    scope.serviceError = true;
                    scope.widgetIsLoading = false;
                });
        };

        if (scope.widget.hasRequiredSettings()) {
            if(!$routeParams.country && !$routeParams.continent)
                scope.fetchData();
            else if($routeParams.country || $routeParams.continent)
                scope.fetchData($routeParams.country, $routeParams.continent);
        } else {
            scope.notConfigured = true;
        }
    };

    return new WidgetDirective(v11nWidget, v11nWidgetLink, v11nWidgetController);
}])
.run(['DashboardWidgetService', 'InformationTypeService', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, InformationTypeService, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {

    DashboardWidgetService.register({
        name: 'Heat Map',
        app: 'v11n',
        enableMaxOverlay:'false',
        description: 'The Heat Map widget provides insight into how coverage of a brand, product, event or topic is broken down by country. Volume of coverage is represented by color saturation and thereby helps you understand in which markets a topic is trending. The widget works best using one input.',
        directive: 'worldclickheat-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            'source': [],
            'maxAgents': 1,
            'size': 200,
            filterPanel: {
                allowedInformationTypes: InformationTypeService.getNormalizedInformationTypes()
            }
        },
        displayOrder: 8,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange','title','news','broadcast', 'social', 'tags', 'mapType', 'labelVisibility'],
        availableMapTypes:[{
            group: [{
                name: 'World Map (countries)',
                id: 'custom/world',
                code: 'world',
                type: 'world'
            }, {
                name: 'World Map (continents)',
                id: 'custom/world-continents',
                code:'world-continents',
                type: 'world'
            }, {
                name: 'Africa',
                id: 'custom/africa',
                code: 'af',
                type: 'continent'
            }, {
                name: 'Asia',
                id: 'custom/asia',
                code: 'as',
                type: 'continent'
            }, {
                name: 'Europe',
                id: 'custom/europe',
                code: 'eu',
                type: 'continent'
            }, {
                name: 'North America',
                id: 'custom/north-america',
                code: 'na',
                type: 'continent'
            }, {
                name: 'Oceania',
                id: 'custom/oceania',
                code: 'ao',
                type: 'continent'
            }, {
                name: 'South America',
                id: 'custom/south-america',
                code: 'sa',
                type: 'continent'
            }, {
                name: 'Nordic Countries',
                id: 'custom/nordic-countries',
                code:'nc',
                type: 'continent'
            }, {
                name: 'Scandinavia',
                id: 'custom/scandinavia',
                code: 'sc',
                type: 'continent'
            }, {
                name: 'Middle East',
                id: 'custom/middle-east',
                code: 'ma',
                type: 'continent'
            }, {
                name: 'Central America',
                id: 'custom/central-america',
                code: 'ca',
                type: 'continent'

            }],
            groupConfig: {
                order: true,
                iconClass: "icon-earth",
                openAccordion: true,
                titleClasses: "groupNameBold capitalize"
            },
            name: "Regional Maps",
            id: "regional-maps",
        }, {
            group: [{
                name: 'Australia',
                id: 'countries/au/au-all',
                code: 'au',
                type: 'country'
            }, {
                name: 'Brazil',
                id: 'countries/br/br-all',
                code: 'br',
                type: 'country'
            },
            {
                name: 'Argentina',
                id: 'countries/ar/ar-all',
                code: 'ar',
                type: 'country'
            },
            {
                name: 'Canada',
                id: 'countries/ca/ca-all',
                code: 'ca',
                type: 'country'
            },
            {
                name: 'France',
                id: 'countries/fr/fr-all',
                code: 'fr',
                type: 'country'
            },
            {
                name: 'Germany',
                id: 'countries/de/de-all',
                code: 'de',
                type: 'country'
            },
            {
                name: 'United States',
                id: 'countries/us/us-all',
                code: 'us',
                type: 'country'
            }],
            groupConfig: {
                order: true,
                iconClass: "icon-pushpin2",
                openAccordion: true,
                titleClasses: "groupNameBold capitalize"
            },
            name: "Detailed Country Maps",
            id: "detailed-country-maps",
        }],
        availableChartTypes: [],
        getDefaultMapType: function(){
            return scope.widget.availableMapTypes[0].group[0];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
